<template>
  <div class="made-order">
    <Row>
      <Col :xs="24" :sm="24">
        <Form :model="formItem" ref="formItem" :inline="true" action="javascript:void(0)">
          <FormItem>
            <Input v-model="formItem.key" clearable placeholder="输入支付订单号/用户..."></Input>
          </FormItem>
          <FormItem>
            <DatePicker
              type="datetimerange"
              format="yyyy-MM-dd"
              @on-change="changeDate"
              style="width: 260px"
              placeholder="下单时间"
            ></DatePicker>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="renderTable('formItem')">查找</Button>&nbsp;
            <Button type="success" :loading="exportLoading" @click="exportOrder()">导出运费订单</Button>
          </FormItem>
        </Form>
      </Col>
    </Row>
    <Table max-height="600" border :columns="list" :data="tablelist" :loading="dataloading"></Table>
    <div style="margin: 10px;overflow: hidden">
      <div style="float: right;">
        <Page
          ref="listPage"
          :total="pages.total"
          :current="pages.current"
          :page-size="pages.size"
          show-elevator
          show-total
          @on-change="changePage()"
        ></Page>
      </div>
    </div>
    <Drawer
      width="50"
      v-model="modal1"
      title="订单详情"
      :mask-closable="false"
      @on-cancel="modal1 = false"
    >
      <Row>
        <Col :xs="24" :md="24">
          <div v-model="detaildata">
            <div>
              <span class="key_name">支付订单编号:</span>
              <span>{{detaildata.pay_order_num}}</span>
            </div>
            <div>
              <span class="key_name">收件人:</span>
              <span>{{detaildata.person}}</span>
            </div>
            <div>
              <span class="key_name">收件电话:</span>
              <span>{{detaildata.phone}}</span>
            </div>
            <div>
              <span class="key_name">收件地址:</span>
              <span>{{detaildata.address}}</span>
            </div>
            <div>
              <span class="key_name">融宝返回:</span>
              <span>{{detaildata.wxreturn_status}}</span>
            </div>
          </div>
        </Col>
        <Col :xs="24" :md="24">
          <Table border stripe :columns="columsgood" :data="datagood"></Table>
        </Col>
      </Row>
    </Drawer>
    <!-- 详情弹层 end -->
  </div>
</template>

<script>
// import expandRow from "./table-expand";

export default {
  name: "made-order",
  data() {
    return {
      payStatusList: [
        { value: 0, label: "未支付" },
        { value: 1, label: "支付中" },
        { value: 2, label: "支付完成" }
      ],
      dataloading: true,
      selectLogistics: [],
      showCreatTypeModal: false,
      modal1: false,
      formItem: {
        key: "",
        phone: "",
        datetime: []
      },
      pages: {
        current: 1,
        total: 0,
        size: 10
      },
      list: [
        {
          title: "id",
          key: "id",
          width: 80
          // fixed:"left"
        },
        {
          title: "支付订单号",
          width: 185,
          key: "pay_order_num"
        },
        {
          title: "下单用户",
          width: 120,
          render: (h, params) => {
            return h(
              "span",
              params.row.user != null ? params.row.user.username : ""
            );
          }
        },
        {
          title: "邮费",
          width: 100,
          key: "fare"
        },
        {
          title: "支付状态",
          width: 100,
          align: "center",
          key: "pay_status",
          render: (h, params) => {
            return h(
              "div",
              params.row.pay_status == "0"
                ? "未支付"
                : params.row.pay_status == "1"
                ? "支付中"
                : "已完成"
            );
          }
        },
        {
          title: "收货人姓名",
          key: "person",
          width: 100,
          tooltip: true
        },
        {
          title: "收货人手机号",
          key: "phone",
          width: 120,
          tooltip: true
        },
        {
          title: "收货地址",
          key: "address",
          width: 200,
          tooltip: true
        },
        {
          title: "订单状态",
          width: 100,
          align: "center",
          key: "status",
          render: (h, params) => {
            return h(
              "tag",
              {
                props: {
                  color: params.row.order_status == "0" ? "success" : "orange"
                }
              },
              params.row.order_status == "0" ? "正常" : "关闭"
            );
          }
        },
        {
          title: "下单时间",
          minWidth: 150,
          key: "created_at"
        },
        {
          title: "操作",
          align: "center",
          key: "action",
          width: 80,
          fixed: "right",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style: {
                    marginRight: "5px"
                  },
                  on: {
                    click: () => {
                      this.detail(params.row.id);
                    }
                  }
                },
                "详情"
              )
            ]);
          }
        }
      ],
      detaildata: [],
      //订单详情
      columsgood: [
        {
          title: "商品订单号",
          key: "order_num",
          width: 200,
          align: "center"
        },
        {
          title: "商品名称",
          width: 120,
          key: "goodtitle",
          align: "center"
        },
        {
          title: "状态",
          align: "center",
          key: "status",
          minWidth: 80,
          render: (h, params) => {
            return h("div", params.row.status == 2 ? "退回" : "正常");
          }
        }
      ],
      tablelist: [],
      datagood: [],
      makedata: {
        status: 1
      },
      makedataValidate: {},
      exportLoading: false
    };
  },
  mounted: function() {
    // 取数据
    this.getTableList();
  },
  methods: {
    // 获取订单列表
    getTableList: function() {
      this.renderTable(1);
      return;
    },
    // 分页
    changePage() {
      this.pages.current = this.$refs["listPage"].currentPage;
      this.renderTable(1);
    },
    changeDate(val) {
      this.formItem.datetime = val;
    },
    cancelorder: function(index) {
      // 弹出确认框
      this.$Modal.confirm({
        title: "警告",
        content: "<p>此操作不可恢复，三思而后行...</p>",
        onOk: () => {
          this.$api.madeorder.cancel({ id: index }).then(res => {
            if (res.code == 200) {
              this.renderTable(1);
            }
          });
        }
      });
    },

    // 查看详情
    detail: function(index) {
      this.modal1 = true;
      this.detaildata = [];
      var params = {
        id: index
      };
      this.$api.mangheorder.fareOrderDetail(params).then(res => {
        if (res.code == 200) {
          this.detaildata.pay_order_num = res.result.pay_order_num;
          this.detaildata.person = res.result.person;
          this.detaildata.phone = res.result.phone;
          this.detaildata.address = res.result.address;
          this.detaildata.repal_returnmsg = res.result.repal_returnmsg;
          this.datagood = res.result.goodorder;
        }
      });
      return;
    },
    // 筛选
    renderTable: function(name) {
      if (name != 1) {
        this.pages.current = 1;
      }
      var pay_begin_at =
        this.formItem.datetime[0] != undefined ? this.formItem.datetime[0] : "";
      var pay_end_at =
        this.formItem.datetime[1] != undefined ? this.formItem.datetime[1] : "";
      let params = {
        page: this.pages.current,
        size: this.pages.size,
        key: this.formItem.key,
        phone: this.formItem.phone,
        pay_begin_at: pay_begin_at,
        pay_end_at: pay_end_at
      };
      this.$api.mangheorder.fareOrderList(params).then(res => {
        if (res.code == 200) {
          this.dataloading = false;
          this.tablelist = res.result.list;
          this.pages.total = res.result.total;
          // for (var i = 0; i < 10; i++) {
          //   this.tablelist[i]._expanded = true;
          // }
          this.$Message.success(res.msg);
        }
      });
    },
    exportOrder() {
      this.exportLoading = true;
      var pay_begin_at =
        this.formItem.datetime[0] != undefined ? this.formItem.datetime[0] : "";
      var pay_end_at =
        this.formItem.datetime[1] != undefined ? this.formItem.datetime[1] : "";
      this.$api.mangheorder
        .exportfareorder({
          pay_begin_at: pay_begin_at,
          pay_end_at: pay_end_at
        })
        .then(res => {
          if (res.code == 200) {
            this.$Message.success(res.msg);
          }
          this.exportLoading = false;
        });
    }
  }
};
</script>

<style scoped>
</style>